module.exports = __webpack_public_path__ + "media/images/paid_game-a2d7fce5e1e7baf61a8056b9e47c56e5.png";